import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { QuicksightDashboardReportPage } from "./quicksight-dashboard-report";

@NgModule({
  declarations: [QuicksightDashboardReportPage],
  imports: [
    IonicPageModule.forChild(QuicksightDashboardReportPage),
    HttpClientModule,
    TranslateModule.forChild(),
    NgSelectModule,
  ],
  exports: [QuicksightDashboardReportPage],
})
export class QuicksightDashboardReportPageModule {}



// WEBPACK FOOTER //
// ./src/pages/order-managment/reports/quicksight-dashboard-report/quicksight-dashboard-report.module.ts